import React from "react";
import styled from "styled-components";
import fipayFonts from "../../theme/index";

interface SocialMedia {
  id: string;
  icon: string;
  link: string;
}

interface TeamMember {
  name: string;
  image: {
    src: string;
    alt: string;
  };
  title: string;
  socialMedia?: SocialMedia[];
}

const teamMembers: TeamMember[] = [
  {
    name: "Ajagbe Debo",
    image: {
      src: "/assets/icons/memberImage.png",
      alt: "Ajagbe Debo Team Member Photo",
    },
    title: "Chief Operating Executive (C.E.O)",
    socialMedia: [
      {
        id: "social-media-3",
        icon: "/assets/icons/twitterIcon.png",
        link: "https://twitter.com/FiPay_io",
      },
      {
        id: "social-media-1",
        icon: "/assets/icons/instagramIcon.png",
        link: "https://www.instagram.com/",
      },
      {
        id: "social-media-4",
        icon: "/assets/icons/gmailIcon.png",
        link: "mailto:contact@fipay.io",
      },
      {
        id: "social-media-5",
        icon: "/assets/icons/linkedInIcon.png",
        link: "https://www.linkedin.com/company/fipay-io/about/?viewAsMember=true",
      },
    ],
  },
  {
    name: "Michael James",
    image: {
      src: "/assets/icons/memberImage1.png",
      alt: "Michael James Team Member Photo",
    },
    title: "Chief Technical Officer (C.T.O)",
    socialMedia: [
      {
        id: "social-media-3",
        icon: "/assets/icons/twitterIcon.png",
        link: "https://twitter.com/FiPay_io",
      },
      {
        id: "social-media-1",
        icon: "/assets/icons/instagramIcon.png",
        link: "https://www.instagram.com/",
      },
      {
        id: "social-media-4",
        icon: "/assets/icons/gmailIcon.png",
        link: "mailto:contact@fipay.io",
      },
      {
        id: "social-media-5",
        icon: "/assets/icons/linkedInIcon.png",
        link: "https://www.linkedin.com/company/fipay-io/about/?viewAsMember=true",
      },
    ],
  },
  {
    name: "Sandra Lui",
    image: {
      src: "/assets/icons/memberImage2.png",
      alt: "Michale James Team Member Photo",
    },
    title: "Head of Operations",
    socialMedia: [
      {
        id: "social-media-3",
        icon: "/assets/icons/twitterIcon.png",
        link: "https://twitter.com/FiPay_io",
      },
      {
        id: "social-media-1",
        icon: "/assets/icons/instagramIcon.png",
        link: "https://www.instagram.com/",
      },
      {
        id: "social-media-4",
        icon: "/assets/icons/gmailIcon.png",
        link: "mailto:contact@fipay.io",
      },
      {
        id: "social-media-5",
        icon: "/assets/icons/linkedInIcon.png",
        link: "https://www.linkedin.com/company/fipay-io/about/?viewAsMember=true",
      },
    ],
  },
  {
    name: "Daniel Steven",
    image: {
      src: "/assets/icons/memberImage3.png",
      alt: "Michale James Team Member Photo",
    },
    title: "Lead Front-end Engineer",
    socialMedia: [
      {
        id: "social-media-3",
        icon: "/assets/icons/twitterIcon.png",
        link: "https://twitter.com/FiPay_io",
      },
      {
        id: "social-media-1",
        icon: "/assets/icons/instagramIcon.png",
        link: "https://www.instagram.com/",
      },
      {
        id: "social-media-4",
        icon: "/assets/icons/gmailIcon.png",
        link: "mailto:contact@fipay.io",
      },
      {
        id: "social-media-5",
        icon: "/assets/icons/linkedInIcon.png",
        link: "https://www.linkedin.com/company/fipay-io/about/?viewAsMember=true",
      },
    ],
  },
  {
    name: "Amanda Sullivan",
    image: {
      src: "/assets/icons/memberImage4.png",
      alt: "Michale James Team Member Photo",
    },
    title: "Lead Back-end Engineer",
    socialMedia: [
      {
        id: "social-media-3",
        icon: "/assets/icons/twitterIcon.png",
        link: "https://twitter.com/FiPay_io",
      },
      {
        id: "social-media-1",
        icon: "/assets/icons/instagramIcon.png",
        link: "https://www.instagram.com/",
      },
      {
        id: "social-media-4",
        icon: "/assets/icons/gmailIcon.png",
        link: "mailto:contact@fipay.io",
      },
      {
        id: "social-media-5",
        icon: "/assets/icons/linkedInIcon.png",
        link: "https://www.linkedin.com/company/fipay-io/about/?viewAsMember=true",
      },
    ],
  },
  {
    name: "Kendrick Wayne",
    image: {
      src: "/assets/icons/memberImage5.png",
      alt: "Michale James Team Member Photo",
    },
    title: "Lead Product Designer",
    socialMedia: [
      {
        id: "social-media-3",
        icon: "/assets/icons/twitterIcon.png",
        link: "https://twitter.com/FiPay_io",
      },
      {
        id: "social-media-1",
        icon: "/assets/icons/instagramIcon.png",
        link: "https://www.instagram.com/",
      },
      {
        id: "social-media-4",
        icon: "/assets/icons/gmailIcon.png",
        link: "mailto:contact@fipay.io",
      },
      {
        id: "social-media-5",
        icon: "/assets/icons/linkedInIcon.png",
        link: "https://www.linkedin.com/company/fipay-io/about/?viewAsMember=true",
      },
    ],
  },
];

const MeetOurTeam: React.FC = () => {
  return (
    <MeetOurTeamContainer>
      <AboutUs>
        <AboutUsContainer>
          <AboutUsText>ABOUT US</AboutUsText>
        </AboutUsContainer>
        <MeetOurTeamTitle>Meet Our Team</MeetOurTeamTitle>
      </AboutUs>
      <TeamMembersContainer>
        {teamMembers.map((member) => (
          <TeamMember key={member.name}>
            <ProfileImage src={member.image.src} alt={member.image.alt} />
            <MemberCardContent>
              <TextWrap>
                <h3>{member.name}</h3>
                <p>{member.title}</p>
              </TextWrap>
              {member.socialMedia && (
                <MemberSocialMedia>
                  {member.socialMedia.map((social) => (
                    <SocialMediaIcon
                      key={social.id}
                      href={social.link}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        src={social.icon}
                        alt={social.id}
                        onClick={() => window.open(social.link)}
                      />
                    </SocialMediaIcon>
                  ))}
                </MemberSocialMedia>
              )}
            </MemberCardContent>
          </TeamMember>
        ))}
      </TeamMembersContainer>
    </MeetOurTeamContainer>
  );
};

const AboutUs = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 0.5rem;
`;

const MeetOurTeamContainer = styled.section`
  padding: 4rem;
  background-color: #ffffff;
  align-items: center;
`;

const MeetOurTeamTitle = styled.h1`
  font-family: GT Walsheim Pro;
  font-size: 38px;
  font-weight: 700;
  line-height: 56px;
  letter-spacing: 0.5px;
  text-align: center;
  margin: 0;
  padding: 0;
  color: #09005b;
  margin-bottom: 2rem;
  @media screen and (min-width: 0px) and (max-width: 766px) {
    font-size: 30px;
    line-height: 34.35px;
    margin-top: 0.5rem;
  }
  ${fipayFonts.fipayFonts.heading1};
`;

const AboutUsText = styled.p`
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
  text-align: centre;
  color: #00c703;
`;

const AboutUsContainer = styled.div`
  background-color: rgba(0, 199, 3, 0.1);
  border-radius: 30px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 14%;
  height: 1%;
  margin-bottom: 1px;

  @media (max-width: 768px) {
    width: 72%;
    height: 1%;
  }
`;

const TeamMembersContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  width: 100%;
  gap: 2rem;
  margin-top: 1rem;
  @media screen and (min-width: 320px) and (max-width: 767px) {
    flex-direction: column;
  }
`;

const TeamMember = styled.div`
  width: 30%;
  height: 21.25rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  position: relative;
  @media screen and (min-width: 320px) and (max-width: 767px) {
    width: 100%;
  }
`;

export const TextWrap = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  top: 62%;
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 0.5rem;
  h3 {
    margin: 0;
    padding: 0;
    font-size: 26.5px;
    font-weight: 600;
  }
  p {
    margin: 0;
    padding: 0;
    color: #5e5e5e;
  }

  @media screen and (min-width: 320px) and (max-width: 767px) {
    margin-top: 0.7rem;
    gap: 1rem;
    h3 {
      font-size: 25px;
      font-weight: 600;
    }
  }
`;

const MemberSocialMedia = styled.div`
  display: flex;
  gap: 2.375rem;
  align-items: center;
  justify-content: center;
  color: #f0f0f0;
  position: absolute;
  bottom: 8%;
  left: 0;
  right: 0;

  @media screen and (min-width: 320px) and (max-width: 767px) {
    bottom: 5%;
  }
`;

const SocialMediaIcon = styled.a`
  text-align: center;
`;

const MemberCardContent = styled.div`
  background-color: #f7f7f7;
  width: 100%;
  height: 100%;
  margin-top: 5rem;
  border-radius: 15px;
  text-align: center;
  display: flex;
  align-items: center;
  flex-direction: column;
  text-align: center;

  @media screen and (min-width: 320px) and (max-width: 767px) {
    width: 124%;
  }
`;

export const ProfileImage = styled.img`
  position: absolute;
  top: 0;
  margin-top: 13px;

  @media screen and (min-width: 320px) and (max-width: 767px) {
    margin-bottom: 22rem;
  }
`;
export default MeetOurTeam;
